import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M12 19.5a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      d: "M12 15.75v-7.5"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.621 1.76a1.806 1.806 0 0 0-3.242 0L.906 21.058a1.52 1.52 0 0 0 1.366 2.192h19.456a1.52 1.52 0 0 0 1.366-2.192z"
    }, null, -1)
  ]));
}
const interfaceAlertExclamationTriangleWarning = { render };
export {
  interfaceAlertExclamationTriangleWarning as default,
  render
};
//# sourceMappingURL=interface-alert-exclamation-triangle-warning.svg.js.map
